import { isNullable, Nullable } from "@core/utils";

export const withoutPrefix = (key: string, ...prefixes: string[]): string => {
  const regex = new RegExp(`^(${prefixes.join("|")})`, "i");

  return key.replace(regex, "");
};

export const toCamelCase = (input?: Nullable<string>): string => {
  if (isNullable(input)) return "";

  return (
    input
      .trim()
      // Lowercase the first character of the entire string
      .replace(/^[A-Z]/, (char) => char.toLowerCase())
      // Lowercase the first character after each dot
      .replace(/\.(.)/g, (_, char) => `.${char.toLowerCase()}`)
      // Remove all dashes and underscores and uppercase
      .replace(/[-_](.)/g, (_, char: string) => char.toUpperCase())
  );
};

export const toKebabCase = (input?: string | null): string => {
  if (!input) return "";

  return (
    input
      .trim()
      // Insert a space between lowercase-uppercase boundaries: "PascalCase" -> "Pascal Case"
      .replace(/([a-z])([A-Z])/g, "$1-$2")
      // Replace underscores and dashes with dashes: snake_case -> snake-case
      .replace(/[_\s]+|[-]+/g, "-")
      // Convert everything to lowercase
      .toLowerCase()
  );
};
